<template>
  <div class="community-popup" @click.self="close">
    <div class="section">
      <div
        class="content"
        :class="[communityInfo.platform === 1 ? 'qq-popup-component' : 'wx-popup-component']"
      >
        <div class="title">{{ currentCommunity.title }}</div>
        <div class="sub-title">{{ currentCommunity.subTitle }}</div>
        <div class="wx-message-img">
          <img :src="communityInfo.qrcode" alt="" />
        </div>
        <div class="tips">
          <span>{{
            !isWechatBrowser ? currentCommunity.desc : currentCommunity.miniDesc
          }}</span>
        </div>
        <div class="footer">
          <div class="footer-btn" v-if="isWechatBrowser && currentCommunity.miniBtnText">
            {{ currentCommunity.miniBtnText }}
          </div>
          <div class="footer-btn" v-if="!isWechatBrowser" @click="oepnCommniuty">
            {{ currentCommunity.btnText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { wechatJSConfig, miniSchemeUrl } from '@/utils/common';

export default {
  components: {},
  data() {
    return {
      communityInfo: {},
      textConfig: {
        '1-1': {
          // qq 群
          desc: '',
          miniDesc: '请长按上方二维码保存图片，前往QQ扫描二维码添加',
          title: '加入备考群',
          subTitle: '领取学习资料和更多小伙伴一起备考',
          btnText: '立即前往QQ添加',
          miniBtnText: '',
        },
        '1-2': {
          // qq 个人
          desc: '',
          miniDesc: '请长按上方二维码保存图片，前往QQ扫描二维码添加',
          title: '添加助教',
          subTitle: '添加助教老师，获得更多课程资料及个性化服务',
          btnText: '立即前往QQ添加',
          miniBtnText: '',
        },
        '2-1-1': {
          // 微信-群-保存二维码
          desc: '截屏保存二维码，打开【微信】扫一扫，在右下角“相册”选择图片进行扫描',
          miniDesc: '请长按上方二维码，添加微信群',
          title: '加入备考群',
          subTitle: '领取学习资料和更多小伙伴一起备考',
          btnText: ' 截屏保存二维码，去微信扫码 ',
          miniBtnText: '',
        },
        '2-2-1': {
          // 微信-个人-保存二维码
          desc: '截屏保存二维码，打开【微信】扫一扫，在右下角“相册”选择图片进行扫描',
          miniDesc: '请长按上方二维码，添加微信号',
          title: '助教老师',
          subTitle: '添加助教老师，获得更多课程资料及个性化服务',
          btnText: ' 截屏保存二维码，去微信扫码 ',
          miniBtnText: '',
        },
        '2-1-3': {
          // 微信-群-跳转小程序
          desc: '点击下方按钮，立即添加',
          miniDesc: '请长按上方二维码，添加微信群',
          title: '加入备考群',
          subTitle: '领取学习资料和更多小伙伴一起备考',
          btnText: '前往微信添加',
          miniBtnText: '',
        },

        '2-2-3': {
          // 微信-个人-跳转小程序
          desc: '点击下方按钮，立即添加',
          miniDesc: '请长按上方二维码，添加微信号',
          title: '助教老师',
          subTitle: '添加助教老师，获得更多课程资料及个性化服务',
          btnText: '前往微信添加',
          miniBtnText: '',
        },
      },
      currentCommunity: {},
      isWechatBrowser: /MicroMessenger/i.test(navigator.userAgent),
    };
  },
  methods: {
    show(data) {
      this.communityInfo = data;
      this.initInfo(data);
    },
    close() {
      this.$emit('hidden');
    },
    initInfo(data) {
      const { platform, accountType, groupEntryMode } = data;
      if (platform === 1) {
        this.currentCommunity = this.textConfig[`${platform}-${accountType}`];
      } else {
        this.currentCommunity = this.textConfig[`${platform}-${accountType}-${groupEntryMode}`];
      }
      console.log(this.currentCommunity, 9999000);
    },
    oepnCommniuty() {
      const { platform } = this.communityInfo;
      if (platform === 2) {
        this.jumpWX();
      } else {
        this.jumpQQ();
      }
    },
    // 微信
    jumpWX() {
      const { platform,groupEntryMode } = this.communityInfo;
      if(platform === 2 &&groupEntryMode === 3){
        this.jumpMini()
        return
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('addWechatGroup', { QRCodeUrl: this.communityInfo?.qrcode }, false);
      } else {
        this.$toast('正在打开微信');
        setTimeout(() => {
          window.location.href = 'weixin://';
        }, 500);
      }
    },
    // qq群
    jumpQQ() {
      const { linkUrl, accountType, account } = this.communityInfo;
      if (this.$root.$data.isApp) {
        if (accountType === 1) {
          this.$sendToApp('addQQGroup', {
            url: linkUrl,
          });
        } else {
          this.$sendToApp('addQQ', {
            QRCodeUrl: account,
            QQNum: account,
          });
        }
      } else if (linkUrl) {
        window.location.href = linkUrl;
      }
    },
    // 打开微信小程序加群页
    async jumpMini() {
      const { id } = this.communityInfo || {};
      if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: `/subPackages/codePage/codePage?communityId=${id}`,
        });
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/codePage/codePage?communityId=${id}`,
        });
      } else {
        const schemeLink = await miniSchemeUrl(
          'wxdb89cfa2bb60f779',
          '/subPackages/codePage/codePage',
          `communityId=${id}`,
        );
        window.location.href = schemeLink;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.community-popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.5);
  .section {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
      min-height: 850px;
  max-height: 928px;
    background: #fff;
    border-radius: 40px 40px 0 0;
    .content {
      position: relative;
      width: 100%;
      min-height: 850px;
      overflow: hidden;
    }
    .wx-popup-component {
      background: url('../../assets/img/productDetail/wx_icon_bg.png') 0 0 no-repeat;
      background-size: 326px 261px;
    }
    .qq-popup-component {
      background: url('../../assets/img/productDetail/qq_icon.png') 0 0 no-repeat;
      background-size: 275px 351px;
    }
    .title {
      width: 100%;
      margin-top: 58px;
      color: #333;
      font-weight: blod;
      font-size: 43px;
      line-height: 60px;
      text-align: center;
    }

    .sub-title {
      width: 100%;
      margin-top: 58px;
      color: #333;
      font-weight: blod;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
    }

    .wx-message-img {
      width: 100%;
      height: 326px;
      margin-top: 43px;
      text-align: center;

      img {
        width: 326px;
        height: 326px;
        border: 2px solid #f5f5f5;
        border-radius: 2px;
      }
    }

    .tips {
      width: 100%;
      padding: 0 90px;
      text-align: center;
      span {
        display: inline-block;
        color: #a5a5a5;
        font-size: 22px;
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      width: 100%;

      .footer-btn {
        width: 634px;
        height: 90px;
        margin-top: 43px;
        color: white;
        font-size: 36px;
        line-height: 90px;
        text-align: center;
        background: #ff6c02;
        border-radius: 14px;
      }
    }
  }
}
</style>
